import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import {
  Collapse,
  CardHeader,
  List,
  Drawer,
  Fab,
  Divider,
  Tooltip,
  Portal,
} from "@material-ui/core";
import { withRouter } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { discussionClient } from "../../../AxiosClient";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import CloseIcon from "@material-ui/icons/Close";
import DiscussionEntries from "../../discussions/DiscussionEntries";
import CreateDiscussion from "../../discussions/CreateDiscussion";
import DisplayTemplate from "../DisplayTemplate";
import ItemDiscussions from "../../list-item/ItemDiscussions";
import classNames from "classnames";
import { Trans, withTranslation } from "react-i18next";

const drawerWidth = 450;

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  fullWidth: {
    height: "100%",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
    overflow: "visible",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    textOverflow: "ellipsis",
    height: "100%",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    textOverflow: "ellipsis",
    width: 0,
    position: "relative",
    height: "100%",
  },
  collapseInner: {
    display: "flex",
  },
  wrapper: {
    height: "100%",
  },
});
class KnowledgeItemDiscussion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      revisionOpen: false,
      discussionOpen: true,
      discussions: [],
      discussion: null,
      createEntryOpen: false,
      openCreateDiscussion: false,
      openCreateEntry: false,
    };
  }
  componentDidMount() {
    this.getDiscussions();
  }
  getDiscussions = () => {
    discussionClient
      .get(`/discussion/?type=KNOWLEDGE_ITEM&itemId=${this.props.ki.itemId}`)
      .then((res) => {
        this.setState({ discussions: res.data.content });
        if (this.props.discussionId) {
          res.data.content.map((discussion) => {
            if (discussion.discussionId === this.props.discussionId) {
              this.onItemClick(discussion);
            }
          });
        }
      });
  };
  removeDiscussion = (discussionId) => {
    let discussions = this.state.discussions.filter(
      (discussion) => discussion.discussionId !== discussionId
    );
    this.setState({ discussions });
  };
  onItemClick = (discussion) => {
    this.setState({ discussion: discussion });
  };
  onRevisionClick = (selectedRevision) => {
    this.setState({ selectedRevision });
  };
  updateDiscussion = (discussion, selected) => {
    selected && this.setState({ discussion });
    let copyDiscussions = [...this.state.discussions];
    copyDiscussions.forEach((d, idx) => {
      if (d.discussionId === discussion.discussionId)
        copyDiscussions[idx] = discussion;
    });
    this.setState({ discussions: copyDiscussions });
  };
  render() {
    let currentPath = this.props.match.url;

    const { classes } = this.props;
    return (
      <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
        <Drawer
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: this.state.discussionOpen,
            [classes.drawerClose]: !this.state.discussionOpen,
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: this.state.discussionOpen,
              [classes.drawerClose]: !this.state.discussionOpen,
            }),
          }}
          // className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={this.state.discussionOpen}
        >
          <CardHeader
            title={<div>Discussions</div>}
            subheader={this.props.ki.description}
            action={
              <>
                <IconButton
                  onClick={() =>
                    this.setState({
                      discussionOpen: !this.state.discussionOpen,
                    })
                  }
                >
                  <CloseIcon />
                </IconButton>
              </>
            }
          />
          <List id="discFour">
            {this.state.discussions.map((item, idx) => {
              return (
                // <Badge
                // 	className={classes.badge}
                // 	badgeContent={this.state.unreadDiscussions ? 1 : 0}
                // 	color="secondary"
                // >
                <ItemDiscussions
                  noMove
                  noFullscreen
                  discussionPortlet={false}
                  onItemClick={this.onItemClick}
                  portlet={false}
                  data={item}
                  removeDiscussion={this.removeDiscussion}
                  canModerate
                  key={item.discussionId}
                  refreshDiscussions={() => this.getDiscussions()}
                />
                // </Badge>
              );
            })}
          </List>
          {!this.state.discussions ||
            (this.state.discussions.length === 0 && (
              <div>
                <Trans i18nKey="no_discussions_for" />{" "}
                {this.props.ki.documentTitle}
              </div>
            ))}
          {!this.state.createEntryOpen && (
            <Fab
              onClick={() => this.setState({ openCreateDiscussion: true })}
              color="primary"
              aria-label={this.props.t("create_discussion_header")}
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
                zIndex: 9999999999,
              }}
            >
              <AddIcon />
            </Fab>
          )}
        </Drawer>

        {!this.state.discussionOpen && (
          <div>
            <IconButton
              aria-label="delete"
              onClick={() => {
                this.setState({ discussionOpen: true });
              }}
            >
              <QuestionAnswerIcon />
            </IconButton>
          </div>
        )}
        <Portal>
          <CreateDiscussion
            expert={true}
            discussionOnId={this.props.ki.itemId}
            knowledgeSourceId={parseInt(this.props.ki.knowledgeSource.sourceId)}
            top={10}
            type="ki"
            open={this.state.openCreateDiscussion}
            addedDiscussion={this.state.addedDiscussion}
            onDiscussionAdded={(discussion) =>
              this.setState({
                discussions: [discussion, ...this.state.discussions],
              })
            }
            changeOpenCreateDiscussion={() =>
              this.setState({ openCreateDiscussion: false })
            }
          />
        </Portal>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            overflowY: "auto",
          }}
        >
          <Collapse
            in={this.state.discussion}
            style={{
              width: this.state.discussion ? "100%" : 0,
              flexDirection: "row",
            }}
            classes={{
              wrapperInner: classes.collapseInner,
              wrapper: classes.wrapper,
            }}
          >
            <div style={{ width: "100%" }}>
              {this.state.discussion && (
                <DiscussionEntries
                  openCreateContent={() =>
                    this.props.history.push({
                      pathname: `/full/discussion/${
                        this.state.discussion.discussionId
                      }`,
                      state: { createContent: true },
                    })
                  }
                  action={
                    <div>
                      <Tooltip title={this.props.t("open_fullscreen")}>
                        <IconButton
                          onClick={() =>
                            this.props.history.push({
                              pathname: `/full/discussion/${
                                this.state.discussion.discussionId
                              }`,
                            })
                          }
                        >
                          <OpenInBrowserIcon />
                        </IconButton>
                      </Tooltip>
                      {/* <IconButton
                        onClick={() => {
                          this.props.history.push({
                            pathname: `/full/knowledgeitem/${
                              this.props.ki.itemId
                            }/discussion/`,
                          });
                          // this.setState({ discussion: null })
                        }}
                      >
                        <ArrowBackIcon />{" "}
                      </IconButton>{" "} */}
                    </div>
                  }
                  discussionId={this.state.discussion.discussionId}
                  showBackButton
                  updateDiscussion={this.updateDiscussion}
                  discussion={this.state.discussion}
                  updateSummary={() => {
                    this.getDiscussions()
                    this.props.updateUnread()
                  }}
                />
              )}
            </div>
            <Divider orientation="vertical" />
          </Collapse>
        </div>
        <Collapse
          in={this.state.selectedRevision}
          style={{
            width: this.state.selectedRevision ? "100%" : 0,
            flexDirection: "row",
          }}
          classes={{
            wrapperInner: classes.collapseInner,
            wrapper: classes.wrapper,
          }}
        >
          <Divider orientation="vertical" />
          {this.state.selectedRevision && (
            <FormControl
              variant="outlined"
              className={classes.formControl}
              style={{ width: "100%" }}
            >
              <DisplayTemplate
                customFields={this.state.selectedRevision.customFields}
                isNotTemplate
                reverseClose
                noEdit
                close
                onClose={() => this.setState({ selectedRevision: null })}
                template={this.state.selectedRevision}
                title={this.state.selectedRevision.title}
              />
            </FormControl>
          )}
        </Collapse>
        {!this.state.revisionOpen && (
          <div>
            <IconButton
              aria-label="delete"
              onClick={() => {
                this.setState({ revisionOpen: true });
              }}
            >
              <LibraryBooksIcon />
            </IconButton>
          </div>
        )}
        <Drawer
          open={this.state.revisionOpen}
          variant="persistent"
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: this.state.revisionOpen,
            [classes.drawerClose]: !this.state.revisionOpen,
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: this.state.revisionOpen,
              [classes.drawerClose]: !this.state.revisionOpen,
            }),
          }}
          anchor="right"
        >
          <div style={{ display: "flex", flexDirection:"column", height:"100%"}}>
          <CardHeader
            title={<div>Revisions</div>}
            subheader={this.props.ki.description}
            action={
              <>
                <IconButton
                  onClick={() =>
                    this.setState({ revisionOpen: !this.state.revisionOpen })
                  }
                >
                  <CloseIcon />
                </IconButton>
              </>
            }
          />
          <div style={{ flex: '1 1 auto' }}>
            {this.props.revisionList && this.props.revisionList()}
          </div>
          </div>
        </Drawer>
      </div>
    );
  }
}
export default withRouter(
  withStyles(styles)(withTranslation()(KnowledgeItemDiscussion))
);
